import Axios from 'axios'
import Vue from 'vue'
import { store } from '../store'

let util = {
  Axios: {
    Get: function (controller, id) {
      store.commit('addRequest')
      if (id) {
        return Axios.get(
          process.env.VUE_APP_ROOT_API + controller + '/' + id
        ).then(HandleResponse, HandleError)
      } else {
        return Axios.get(
          process.env.VUE_APP_ROOT_API + controller
        ).then(HandleResponse, HandleError)
      }
    },
    GetAll: function (controller, dto, fromQuery) {
      store.commit('addRequest')
      if (!fromQuery) {
        return Axios.get(process.env.VUE_APP_ROOT_API + controller, {
          params: { dto: dto }
        }).then(HandleResponse, HandleError)
      } else {
        return Axios.get(process.env.VUE_APP_ROOT_API + controller, {
          params: dto
        }).then(HandleResponse, HandleError)
      }
    },
    GetBlob: function (controller, dto) {
      store.commit('addRequest')
      return Axios.get(process.env.VUE_APP_ROOT_API + controller, {
        params: { dto: dto },
        responseType: 'blob' // Force to receive data in a Blob Format
      }).then(HandleResponse, HandleError)
    },
    PostBlob: function (controller, dto) {
      store.commit('addRequest')
      return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto, { responseType: 'blob' }).then(
        HandleResponse,
        HandleError
      )
    },
    Post: function (controller, dto) {
      store.commit('addRequest')
      return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto).then(
        HandleResponse,
        HandleError
      )
    },
    PostForm: function (controller, dto) {
      store.commit('addRequest')
      return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto, { headers: { 'Content-Type': 'multipart/form-data' } }).then(
        HandleResponse,
        HandleError
      )
    },
    Put: function (controller, id, dto) {
      store.commit('addRequest')
      if (!dto) {
        dto = {}
      }
      return Axios.put(
        process.env.VUE_APP_ROOT_API + controller + '/' + id,
        dto
      ).then(HandleResponse, HandleError)
    },
    Patch: function (controller, dto) {
      store.commit('addRequest')
      if (!dto) {
        dto = {}
      }
      return Axios.patch(
        process.env.VUE_APP_ROOT_API + controller,
        dto
      ).then(HandleResponse, HandleError)
    },
    Persist: function (controller, dto) {
      if (!dto) {
        dto = {}
      }
      if (dto.codigo) { return util.Axios.Put(controller, dto.codigo, dto) } else { return util.Axios.Post(controller, dto) }
    },
    DeleteAll: function (controller, dto) {
      store.commit('addRequest')
      return Axios.delete(process.env.VUE_APP_ROOT_API + controller, { params: dto })
        .then(HandleResponse, HandleError)
    },
    Delete: function (controller, id) {
      store.commit('addRequest')
      return Axios.delete(process.env.VUE_APP_ROOT_API + controller + '/' + id)
        .then(HandleResponse, HandleError)
    },
    GetProperty: function (controller, property) {
      store.commit('addRequest')

      return Axios.get(
        process.env.VUE_APP_ROOT_API + controller + '/' + property
      ).then(HandleResponse, HandleError)
    },
    GetParams: function (controller, paramns) {
      store.commit('addRequest')
      if (!paramns) { paramns = {} }
      return Axios.get(process.env.VUE_APP_ROOT_API + controller, { params: paramns })
        .then(HandleResponse, HandleError)
    }
  },
  Functions: {
    CopyObject: function (sender) {
      return JSON.parse(JSON.stringify(sender))
    },
    GridSituacaoCirculo: function (e, ref) {
      let itemTemplate = Vue.component('SituacaoCirculo', store.getters.situacaoCirculo)

      return {
        template: itemTemplate,
        templateArgs: Object.assign({}, e, {
          data: ref.$attrs ? ref.$attrs : ref.data.attrs,
        })
      }
    },
    GridButtom: function (e, ref) {
      var itemTemplate = Vue.component(store.getters.gridButtom.name, store.getters.gridButtom)
      return {
        template: itemTemplate,
        templateArgs: Object.assign({}, e, {
          data: ref.$attrs ? ref.$attrs : ref.data.attrs
        })
      }
    },
    GridCheckbox: function (e, ref) {
      var itemTemplate = Vue.component('GridCheckBox', store.getters.gridCheckbox)
      return {
        template: itemTemplate,
        templateArgs: Object.assign({}, e, {
          data: ref.$attrs ? ref.$attrs : ref.data.attrs,
          id: ref.data.attrs.id
        })
      }
    },
    SaveFile(data, name) {
      let csvContent = "data:text/csv;charset=utf-8," + data.map(e => e.join(";")).join("\n")
      var encodedUri = encodeURI(csvContent)
      window.open(encodedUri)
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", `${name}.csv`)
      document.body.appendChild(link)
      link.click()
    },
  },
  GetCrud: function (controller, methods) {
    var factory = {}
    if (!methods || (methods && methods.indexOf('get') >= 0)) {
      factory.Get = function (id) {
        return util.Axios.Get(controller, id)
      }
    }

    if (!methods || (methods && methods.indexOf('getall') >= 0)) {
      factory.GetAll = function (dto) {
        return util.Axios.GetAll(controller, dto)
      }
    }

    if (!methods || (methods && methods.indexOf('post') >= 0)) {
      factory.Post = function (dto) {
        return util.Axios.Post(controller, dto)
      }
    }

    if (!methods || (methods && methods.indexOf('put') >= 0)) {
      factory.Put = function (id, dto) {
        return util.Axios.Put(controller, id, dto)
      }
    }

    if (!methods || (methods && methods.indexOf('persist') >= 0)) {
      factory.Persist = function (dto) {
        return util.Axios.Persist(controller, dto)
      }
    }

    if (!methods || (methods && methods.indexOf('delete') >= 0)) {
      factory.Delete = function (id) {
        return util.Axios.Delete(controller, id)
      }
    }

    return factory
  },
  CalculaDataDiasUteis: function (data, dias, direcao) {
    while (dias > 0) {
      let isFimDeSemana
      data.setDate(data.getDate() + direcao)
      isFimDeSemana = data.getDay() in { 0: 'Sunday', 6: 'Saturday' }
      if (!isFimDeSemana) dias--
    }
    return data
  }
}

function HandleResponse(response) {
  store.commit('removeRequest')
  let data = response.data
  if (typeof data === 'object' && data !== null) { data.statusCode = response.status }
  return data
}

function HandleError(error) {
  store.commit('removeRequest')
  if (error) {
    if (error.response) {
      if (error.response.status == 403) {
        return { error: 'O perfil associado ao seu operador não permite essa ação.' }
      }
      let data = error.response.data
      if (typeof data === 'object' && data !== null) { data.statusCode = error.status }
      return data
    }
    return error
  }
  return { error: 'Erro' }
}

export default util
